module.exports = __webpack_public_path__ + "static/media/logo.ab3cd426.svg";